module.exports = __webpack_public_path__ + "static/media/p33kz.cd8a5f6a.pdf";